import { render, staticRenderFns } from "./StatusDisplay.vue?vue&type=template&id=0a087508&"
import script from "./StatusDisplay.vue?vue&type=script&lang=js&"
export * from "./StatusDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports